import cn from 'classnames';
import map from 'lodash/map';
import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useInventoryPurchaseTemplatesCreateOrderCreateMutation } from '@services/df/inventory';
import { useAppDispatch, useAppSelector } from '@app/hooks';
import { CounterButton } from '@components/counter-button';
import { inventoryPageActions, selectInventorySelectedIds } from '@modules/inventory-page';
import { modelsActions } from '@modules/models';
import { selectOrderId } from '@modules/order';
import { useBuildLocation } from '@hooks';
import { getNodeIdComposer } from '@utils';
import { useGetOrderUrl } from '@pages/widget/order/hooks';
import { RootPrefix } from './constants';

const _id = getNodeIdComposer(RootPrefix, 'footer');

export const InventoryFooter: React.FC = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const [createOrUpdateOrder, { isLoading }] = useInventoryPurchaseTemplatesCreateOrderCreateMutation();

    const [getOrderUrl] = useGetOrderUrl();
    const orderLocation = useBuildLocation({
        to: getOrderUrl(),
    });
    const selectedInventoryIds = useAppSelector(selectInventorySelectedIds);
    const currentOrderId = useAppSelector(selectOrderId);

    const quote = useCallback(async () => {
        const ids = selectedInventoryIds.map(id => parseInt(id));

        try {
            const order = await createOrUpdateOrder({
                templatesIdsRequestRequest: { order_id: currentOrderId, template_ids: ids },
            }).unwrap();

            dispatch(modelsActions.addSelectedModels(map(order.products, 'parent_model_id')));
            dispatch(inventoryPageActions.selectedIdsChanged([]));
            navigate(orderLocation.to);
        } catch (e) {}
    }, [dispatch, navigate, orderLocation.to, createOrUpdateOrder, currentOrderId, selectedInventoryIds]);

    const count = selectedInventoryIds.length.toString();
    const isQuoteDisabled = !Boolean(selectedInventoryIds.length);

    const { t } = useTranslation();

    return (
        <div className={cn('base-paddings', 'no-top')}>
            <CounterButton
                id={_id('quote')}
                count={count}
                onClick={quote}
                disabled={isQuoteDisabled || isLoading}
                isSending={isLoading}
            >
                {t('buttons.quote', 'Quote')}
            </CounterButton>
        </div>
    );
};
